import owd from 'owd/owd';

export default class Tooltip extends owd.Component {
	init() {
        this.tooltip = this.$element.find('.tooltip');
		this.bind();
	}
    
    initAttribiutes() {
        //this.tooltip.attr({
        //    'aria-hidden': true,
        //    'role': 'tooltip'
        //});
    }

	bind() {   
        this.on('mouseover', (e) => {
            //if(this.$element.is(':hover')) {
            //    console.log('hover');
            //}
            //console.log(this.$element.is(':hover'));
            //const target = $(e.currentTarget);
        });
        
        this.on('mouseout', (e) => {
            //console.log('out');
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('tooltip', {
	component: Tooltip
});
